export default {
  common: {
    cancel: "Cancelar",
    add: "Añadir",
    back: "Atrás", 
    next: "Siguiente", 
    submit: "Enviar",
    saving: "Guardando…",
    saved: "Guardado ✓"
  },
  menu: {
    backToDashboard: "Volver al panel",
    myObjects: "Mis alojamientos",
    settings: "Configuración",
    help: "Ayuda / Contacto",
    logout: "Cerrar sesión",
    language: "Español",
  },

  contact: {
    title: "Contacto",
    subtitle: "¿Cómo podemos ayudarte?",
    messageLabel: "Tu mensaje",
    send: "Enviar mensaje",
    success: "¡Mensaje enviado con éxito!",
    close: "Cerrar",
  },

  dashboard: {
    welcome: "Bienvenido de nuevo, ",
    overview: "Mi resumen",
    summaryText: "Aquí encontrarás una vista rápida del estado de tus alojamientos.",
    activeObjects: "Alojamiento(s) online",
    inReviewObjects: "Alojamiento(s) en revisión",

    contact: "Mis datos de contacto",
    editContact: "Editar",

    settings: "Mi configuración",
    subscription: "Suscripción",
    subscriptionActive: "Activa",
    password: "Contraseña",
    changePassword: "Cambiar contraseña",

    objects: "Mis alojamientos",
    objectboxText: "Introducir disponibilidad y precios",
    objectboxText2: "Editar datos del alojamiento",
    objectbuttonText: "Gestionar alojamientos",

    newObjectContainer: "Crear nuevo alojamiento",
    newObjectDescription: "Crea un nuevo alojamiento o continúa una creación ya iniciada.",
    continueDraft: "➜ Continuar con la creación",
    newObject: "+ Crear nuevo alojamiento",

    documents: "Documentos",
    lastInvoice: "Última factura",
    openArchive: "Abrir archivo",
  },

  contactEdit: {
    title: "Editar datos de contacto",
    errorLoading: "Error al cargar los datos.",
    errorSaving: "Error al guardar los datos.",
    confirmLeave: "¿Deseas guardar los cambios?",
    salutation: "Tratamiento",
    selectSalutation: "Selecciona un tratamiento",
    company: "Empresa",
    firstName: "Nombre",
    lastName: "Apellido",
    street: "Calle",
    houseNumber: "Número",
    postalCode: "Código postal",
    town: "Ciudad / Localidad",
    country: "País",
    selectCountry: "Selecciona un país",
    phone: "Número de teléfono",
    cancel: "Cancelar",
    save: "Guardar",
    requiredFields: "Por favor, completa todos los campos obligatorios.",
  },

  registerUser: {
    title: "Datos de contacto",
    verifiedMessage:
      "Tu correo electrónico ha sido verificado correctamente. Ahora introduce tus datos de contacto.",

    salutation: "Tratamiento",
    selectSalutation: "Selecciona un tratamiento",
    company: "Empresa (opcional)",
    firstName: "Nombre",
    lastName: "Apellido",
    street: "Calle",
    houseNumber: "Número",
    postalCode: "Código postal",
    town: "Ciudad / Localidad",
    country: "País",
    selectCountry: "Selecciona un país",

    phone: "Número de teléfono",
    phonePlaceholder: "Número de teléfono",
    phoneCodePlaceholder: "Prefijo",
    search: "Buscar...",
    noResults: "Sin resultados",

    terms: "Acepto los",
    termsLink: "Términos y condiciones",
    privacy: "Acepto la",
    privacyLink: "política de privacidad",

    save: "Guardar datos",

    requiredFields: "Por favor, completa todos los campos obligatorios.",
    acceptTerms: "Acepta los términos y la política de privacidad.",
    loginFirst: "Por favor, inicia sesión primero.",
    errorSaving: "¡Error al guardar los datos!",
    errorLoading: "Error al cargar los datos.",
  },

  password: {
    title: "Cambiar contraseña",
    oldPassword: "Contraseña actual",
    newPassword: "Nueva contraseña",
    confirmPassword: "Confirmar nueva contraseña",

    cancel: "Cancelar",
    save: "Guardar",

    errorInvalid: "Por favor, completa todos los campos correctamente.",
    errorGeneral: "Error al cambiar la contraseña.",
    success: "Contraseña cambiada con éxito.",
    confirmLeave: "¿Deseas guardar los cambios?",
  },

  impressum: {
    title: "Aviso legal",
    company: "glampingoase GmbH",
    addressLine1: "Breechliweg 3",
    addressLine2: "5102 Rupperswil",
    country: "Suiza",

    registryNumber: "Número de registro: CHE-432.303.436",
    registryCourt: "Registro mercantil del cantón de Argovia",

    emailLabel: "Correo electrónico",
  },

  footer: {
    impressum: "Aviso legal",
  },

  objectList: {
    title: "Gestionar disponibilidad y precios",
    loading: "Cargando...",
    notConfirmed: "aún no confirmado",
    editPrices: "Editar precios",
    editAvailability: "Editar disponibilidad",
    noObjectsLine1: "Todavía no has creado ningún alojamiento.",
    noObjectsLine2: "¿Quieres crear uno ahora?",
    createObject: "Crear nuevo alojamiento",
    imageAlt: "Imagen del alojamiento",
  },

  prices: {
    openCalendar: "Abrir calendario",
    datePlaceholder: "dd.mm.aaaa",
    object: "Alojamiento",

    errorFetchCurrency: "Error al cargar la moneda",
    errorFetchObjects: "Error al cargar los alojamientos",
    errorFetchObjectName: "Error al cargar el nombre del alojamiento",
    errorFetchSeasons: "Error al cargar las temporadas",
    errorFetchSeasonsAlert: "Hubo un problema al cargar las temporadas.",
    errorNotLoggedIn: "No has iniciado sesión.",
    errorMissingFields: "Por favor, completa todos los campos.",
    errorEndBeforeStart: "La fecha de fin no puede ser anterior a la fecha de inicio.",
    errorOverlap: "Esta temporada se superpone con otra existente.",

    errorSaveSeason: "Error al guardar la temporada",
    errorApiRequest: "Error en la solicitud API",
    errorSaveSeasonAlert: "Hubo un problema al guardar la temporada.",

    confirmDeleteSeason: "¿Deseas eliminar la temporada",
    errorDeleteSeason: "Error al eliminar la temporada",
    errorDeleteSeasonAlert: "No se pudo eliminar la temporada.",

    errorFinishEditingFirst:
      "Por favor, termina la edición actual antes de añadir una nueva temporada.",

    tabPrices: "Precios",
    tabAdditionalCosts: "Costes adicionales",
    tabCurrency: "Moneda",
    tabAvailability: "Disponibilidad",
    tabObjectList: "Resumen de alojamientos",

    pricesFor: "Precios para",

    hidePastSeasons: "Ocultar temporadas pasadas",
    showPastSeasons: "Mostrar temporadas pasadas",

    seasonName: "Nombre de la temporada",
    pricePerNight: "Precio por noche en",

    saving: "Guardando...",
    cancel: "Cancelar",
    addSeason: "+ Añadir temporada",

    infoTitle: "¿Cómo introducir precios?",

    infoText:
      "Para cada temporada defines un periodo con fecha de inicio y fin.\n\n" +
      "Puedes asignar cualquier nombre a la temporada. Es solo para tu organización interna y no se muestra a los clientes.\n\n" +
      "El precio corresponde al coste por noche. Asegúrate de que los periodos no se superpongan. Si lo hacen, aparecerá un mensaje de error.\n\n" +
      "Cuando todos los datos sean correctos, confirma con la marca verde. La temporada se guardará y podrás añadir otra.\n\n" +
      "Solo puedes editar una temporada a la vez, ya que cada cambio activa una comprobación automática de solapamientos.\n\n" +
      "Las temporadas guardadas pueden editarse con el icono del lápiz o eliminarse con el icono de la papelera. Estas acciones solo están disponibles si no estás editando otra temporada.\n\n" +
      "Puedes mostrar temporadas pasadas con el botón 'Mostrar temporadas pasadas'. Son solo informativas y no pueden editarse.",

    close: "Cerrar",

    selectCurrencyTitle: "Seleccionar moneda",
    selectCurrencyText: "Elige una moneda antes de añadir precios.",
    currencyRequired: "Selecciona primero una moneda.",

  },

  additionalCosts: {
    title: "Costes adicionales para",
    object: "Alojamiento",

    add: "Añadir coste adicional",

    selectType: "Seleccionar tipo de coste",
    selectUnit: "Seleccionar unidad",
    pricePlaceholder: "Precio en",

    saving: "Guardando...",
    cancel: "Cancelar",

    finishEditingFirst:
      "Por favor, termina la edición actual antes de añadir nuevos costes.",
    fillAllFields: "Por favor, completa todos los campos.",
    confirmDelete: "¿Deseas eliminar este coste?",

    errorLoadingTypes: "Error al cargar los tipos de coste",
    errorLoadingUnits: "Error al cargar las unidades",
    errorLoadingCosts: "Error al cargar los costes adicionales",
    errorSaving: "Error al guardar",
    errorDeleting: "Error al eliminar",
  },

  currency: {
    title: "Moneda para",
    select: "Seleccionar moneda",
    saving: "Guardando...",
    save: "Guardar moneda",
    saved: "Moneda guardada con éxito",
    errorLoadingCurrencies: "Error al cargar las monedas disponibles",
    errorLoadingObjectCurrency: "Error al cargar la moneda del alojamiento",
    errorLoadingObjectName: "Error al cargar el nombre del alojamiento",
    errorSaving: "Error al guardar la moneda",
    object: "Alojamiento",
  },

availability: {
  settingsTitle: "Configuración",
  modeTitle: "Modo de disponibilidad",
  modeIcal: "Sincronización iCal",
  modeManual: "Disponibilidad manual",

  warningSwitch: "Cambiar el modo eliminará las disponibilidades existentes. ¿Continuar?",
  saved: "Configuración guardada.",

  modalTitle: "¿Cómo deseas gestionar tus disponibilidades?",
  modalText: "Elige una de las dos opciones. Puedes cambiarla en cualquier momento.",
  chooseIcal: "Sincronización iCal",
  chooseManual: "Entrada manual",

  errorLoading: "Error al cargar las disponibilidades.",
  tabsAriaLabel: "Pestañas de disponibilidad",

  tabSettings: "Configuración",
  tabIcal: "Gestionar iCal",
  tabManual: "Introducir disponibilidad",
  tabPrices: "Precios",
  tabObjectList: "Lista de objetos"
},

availabilityManual: {
  editAvailability: "Editar disponibilidad",
  loadingObject: "Cargando información del objeto…",

  legendAvailable: "Disponible",
  legendDelete: "Eliminar",

  savedSuccess: "Disponibilidades guardadas correctamente!",
  savedPartialError: "Algunas disponibilidades no pudieron guardarse o eliminarse.",
  errorSaving: "Error al guardar.",
  errorNoObjectId: "Error: no se encontró ID del objeto."
},

availabilityIcal: {
  title: "Importación iCal",
  loading: "Cargando…",

  placeholderUrl: "https://ejemplo.com/calendario.ics",
  testPreview: "Probar vista previa",
  testing: "Probando…",
  showSynced: "Ver datos sincronizados",

  save: "Guardar",
  saving: "Guardando...",
  remove: "Eliminar",

  lastSync: "Última sincronización",
  previewFailed: "Vista previa fallida",
  previewCalendar: "Vista previa (calendario)",

  prev: "Atrás",
  next: "Siguiente",

  errorLoading: "Error al cargar los datos iCal.",
  errorNoUrl: "No se proporcionó un enlace iCal.",
  errorPreview: "Hubo un error al obtener el enlace.",
  errorInvalidUrl: "URL no válida.",
  errorSaving: "Error al guardar.",
  errorRemove: "Error al eliminar",
  removed: "Enlace iCal eliminado",
  saved: "Enlace iCal guardado. Sincronización iniciada.",
  errorLoadSynced: "Error al cargar los datos sincronizados.",
  errorNoObjectId: "No se encontró ID del objeto."
},


  newObjectModal: {
    title: "Alojamiento sin terminar encontrado",
    description:
      "Ya has empezado a crear un alojamiento. ¿Deseas continuar o empezar de nuevo sobrescribiendo los datos existentes?",
    continue: "Continuar con la creación",
    startNew: "Empezar de nuevo",
  },

  object: {
    tabs: [
      "Datos básicos",
      "Habitaciones",
      "Equipamiento / Entorno",
      "Ocupación",
      "Descripción",
      "Imágenes",
      "Enviar"
    ],

    step1: {
      title: "Paso 1: Información general",

      fields: {
        name: "Nombre del alojamiento",
        street: "Calle",
        house_number: "Número",
        postal_code: "Código postal",
        city: "Ciudad",
        object_type: "Tipo de alojamiento",
        country: "País",
        region: "Región",
        licence_number: "Número de licencia",
      },

      select: {
        choose: "Seleccionar",
      },

      map: {
        info: "El marcador se coloca automáticamente según la dirección introducida. Si no es preciso, puedes moverlo manualmente.",
        reset: "Restablecer marcador a la dirección introducida",
        load_error: "No se puede cargar el mapa.",
        loading: "Cargando mapa...",
      },

      geocode: {
        failed: "Error en la geocodificación.",
        missing_fields:
          "Por favor, completa todos los campos de la dirección y verifica que la API de Google Maps esté cargada.",
      },
    },
      step2: {
        title: "Paso 2: Habitaciones y equipamiento",
        addRoom: "Añadir habitación",
        roomCountTitle: "¿Cuántas habitaciones tiene tu alojamiento?",
        roomCountDescription: "Introduce la cantidad por tipo de habitación. Después podrás editarlas individualmente.",
        roomCountSharedHint: "Las habitaciones compartidas como baño y cocina también cuentan.",
        addAllRooms: "Añadir todas las habitaciones",
        roomType: "Tipo de habitación",
        amount: "Cantidad",
        select: "Seleccionar",
        usage: "Uso",
        private: "Uso privado",
        shared: "Uso compartido",
        onlyOneAllowed: "solo 1 permitido",

        // Beds
        beds: "Camas",
        addBed: "Añadir cama",
        bedType: "Tipo de cama",
        size: "Tamaño",
        sizeWidth: "Ancho (cm)",
        sizeLength: "Largo (cm)",
        sizeOptional: "Opcional",
      },
    step3: {
        title: "Paso 3: Equipamiento y entorno",
        general: "Equipamiento general",
        outdoor: "Equipamiento exterior",
        environmentAmenities: "Equipamiento del entorno",
        environmentCards: "Entorno",
        errorLoading: "Error al cargar el equipamiento."
      },
      step4: {
        title: "Paso 4: Ocupación y opciones de contacto",

        maxOccupancy: "Ocupación máxima",
        maxPets: "Número máximo de mascotas",
        minNights: "Estancia mínima",

        selectPlaceholder: "Seleccione",

        arrivalDays: "Días de llegada",

        earliestCheckin: "Check-in más temprano",
        latestCheckout: "Check-out más tarde",

        rules: "Normas",
        partyAllowed: "Fiestas permitidas",
        smokingAllowed: "Fumar permitido",
        yes: "Sí",
        no: "No",

        contactOptions: "Opciones de contacto",
        contactHow: "¿Cómo deben contactarte los huéspedes?",
        contactBoth: "Ambos",
        contactWebsite: "Sitio web",
        contactWebsitePlaceholder: "https://example.com",
        contactEmail: "Correo electrónico para formulario de contacto",

        invalidEmail: "Introduce una dirección de correo válida.",
        errorLoadingArrivalDays: "Error al cargar los días de llegada."
      },
      step5: {
        title: "Paso 5: Descripción del alojamiento",
        activitiesTitle: "Actividades cercanas",
        activitiesPlaceholder: "Describe qué pueden encontrar los huéspedes cerca de tu alojamiento.",
        descriptionTitle: "Descripción del alojamiento",
        descriptionPlaceholder: "Introduce un texto claro que describa bien el alojamiento."
      },
      step6: {
        title: "Paso 6: Subir imágenes",

        titleImage: "Imagen principal",
        additionalImages: "Imágenes adicionales (máx. 20)",

        selectOrDragTitle: "Selecciona o arrastra aquí tu imagen principal",
        dragTitleHere: "Arrastra aquí tu imagen principal",

        selectOrDragAdditional: "Selecciona archivos o arrástralos aquí",
        dragAdditionalHere: "Arrastra aquí imágenes adicionales",

        uploaded: "Imagen subida",
        uploadedCount: "{n} imagen(es) subida(s)",

        errorMinSize: "La imagen debe tener al menos {w}x{h} píxeles.",
        errorInvalidFormat: "Formato de imagen no válido."
      },
      step7: {
        title: "Paso 7: Finalizar y elegir suscripción",
        intro: "¡Casi listo! Elige tu plan y revisa que todos los pasos estén completos.",

        subscriptionTitle: "Elegir plan",

        freeTitle: "Free",
        freePrice: "Gratis",
        freeDescription: "Texto de ejemplo. Aquí va la descripción.",

        monthlyTitle: "Mensual",
        monthlyPrice: "2 CHF / mes",
        monthlyDescription: "Texto de ejemplo. Aquí va la descripción.",

        yearlyTitle: "Anual",
        yearlyPrice: "20 CHF / año",
        yearlyDescription: "Texto de ejemplo. Aquí va la descripción.",

        overviewTitle: "Resumen de tu información",
        fix: "Completar",

        overviewItems: [
          { step: 1, title: "Datos básicos" },
          { step: 2, title: "Habitaciones" },
          { step: 3, title: "Equipamiento / Entorno" },
          { step: 4, title: "Ocupación" },
          { step: 5, title: "Descripción" },
          { step: 6, title: "Imágenes" }
        ],

        errorUnknown: "Error desconocido.",
        errorGeneral: "Ha ocurrido un error."
      }



  },
};
